import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ExerciciosService } from 'src/app/services/exercicios.service';

@Component({
    selector: 'app-enviar-homologacao-para-folha',
    templateUrl: './enviar-homologacao-para-folha.html',
    styleUrls: ['./enviar-homologacao-para-folha.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EnviarHomologacaoParaFolhaComponent implements OnInit {
    idsFerias = '';

    itensParaEnvio = [];

    resultado = [];

    exibirContinuar = false;

    processando = false;

    constructor(private exerciciosService: ExerciciosService) {}

    ngOnInit() {}

    async enviarItensLista() {
        if (this.processando) {
            return;
        }

        this.processando = true;

        try {
            for (const item of this.itensParaEnvio) {
                if (!item.processado) {
                    item.processado = true;
                    try {
                        await firstValueFrom(this.exerciciosService.enviarHomologacaoParaFolha(item.idFerias));
                        item.sucesso = true;
                        this.resultado.push({
                            sucesso: true,
                            idFerias: item.idFerias
                        });
                    } catch (error) {
                        item.sucesso = false;
                        this.resultado.push({
                            sucesso: false,
                            idFerias: item.idFerias
                        });
                    }
                }
            }
        } finally {
            this.exibirContinuar = this.itensParaEnvio.some(item => !item.processado);
            this.processando = false;
        }
    }

    enviarHomologacao() {
        this.idsFerias.split(',').forEach(id => {
            this.itensParaEnvio.push({
                idFerias: id,
                sucesso: false,
                processado: false
            });
        });

        this.enviarItensLista();
        this.exibirContinuar = true;
    }

    continuarEnvio() {
        this.enviarItensLista();
    }
}
